import { FC } from 'react';

const MAX_FILL_PORTION = 10;

interface Props {
  displayNumber?: boolean;
  height?: number;
  minimumStarsToDisplay?: number;
  rating?: number;
}

export const StarRating: FC<Props> = ({
  displayNumber = false,
  height = 14,
  minimumStarsToDisplay = 5,
  rating = 0,
}) => {
  const floored = Math.floor(rating);
  const maxStars = Math.max(rating, minimumStarsToDisplay);
  const stars = Array.from({ length: maxStars }, (_, index) => {
    if (index < floored) {
      return MAX_FILL_PORTION;
    }
    if (index === floored) {
      return Math.floor((rating - floored) * MAX_FILL_PORTION);
    }
    return 0;
  });

  return (
    <div
      className="react-star-rating"
      aria-label={`Rating: ${rating} out of ${maxStars} stars`}
      data-test-id="star-rating"
    >
      {stars.map((filledPortion, index) => (
        <img
          alt=""
          aria-hidden="true"
          height={height}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          loading="lazy"
          src={`/static/images/stars/star-${filledPortion}.svg`}
          width={height}
        />
      ))}
      {displayNumber && <p className="react-star-rating-number">{rating}</p>}

      <style jsx>
        {`
          .react-star-rating {
            align-items: center;
            display: flex;
          }

          .react-star-rating-number {
            margin: 0;
            color: #ffb74d;
            font-size: 16px;
            font-weight: bold;
            padding-left: 8px;
          }

          .react-star-rating img {
            height: ${height}px;
            margin-right: 3px;
          }

          .react-star-rating img:last-child {
            margin-right: 0;
          }
        `}
      </style>
    </div>
  );
};

export default StarRating;
export type { Props as StarRatingProps };
